
import React from 'react'
import GoogleMapSearch from '../../../../../common/components/google-map-search'

export default function ParcelLocationComponent({ setDropLocation, setPickupLocation, quoteData, dropLocations, pickupLocations, libraryData, handleChange }: any) {

    return (

        <div className="w-full font-bold space-y-4">
            {/* Shipping Option */}
            <div className="w-full">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">
                    Shipping Option <span className="text-red-500">*</span>
                </label>
                <select
                    required
                    className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    id="default"
                    onChange={(event: any) => handleChange(event.target.value, 'type')}
                    value={quoteData?.type}
                >
                    <option>--Select--</option>
                    {libraryData?.result?.ShippingOption?.map((item: any, index: any) => (
                        <option value={item.Text} key={index}>{item.Text}</option>
                    ))}
                </select>
            </div>

            {/* Pickup Section */}
            <div className="w-full">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">
                    Pickup Details <span className="text-red-500">*</span>
                </label>
                <GoogleMapSearch
                    required
                    className="w-full font-normal  ps-8  pe-10 py-2 border rounded-md bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    setLocation={setPickupLocation}
                    location={pickupLocations}
                    placeholder="Pickup Address"
                />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="w-full">
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">Name <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        name="pickupName"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => handleChange(event.target.value, 'pickupName')}
                        value={quoteData?.pickupName}
                    />
                </div>
                <div className="w-full">
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">Phone Number <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        maxLength={10}
                        name="pickupPhoneNumber"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => handleChange(event.target.value.replace(/\D/g, ''), 'pickupPhoneNumber')}
                        value={quoteData?.pickupPhoneNumber}
                    />
                </div>
            </div>

            <div className="w-full">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">
                    Pickup Address Additional Info
                </label>
                <input
                    type="text"
                    name="startBuilding"
                    className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    onChange={(event: any) => handleChange(event.target.value, 'startBuilding')}
                    value={quoteData?.startBuilding}
                />
            </div>

            {/* Drop Section */}
            <div className="w-full">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">
                    Drop Details <span className="text-red-500">*</span>
                </label>
                <GoogleMapSearch
                    required
                    className="w-full font-normal  ps-8  pe-10 py-2 border rounded-md bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    setLocation={setDropLocation}
                    location={dropLocations}
                    placeholder="Drop Address"
                />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="w-full">
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">Name <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        name="dropName"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => handleChange(event.target.value, 'dropName')}
                        value={quoteData?.dropName}
                    />
                </div>
                <div className="w-full">
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">Phone Number <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        maxLength={10}
                        name="dropPhoneNumber"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => handleChange(event.target.value.replace(/\D/g, ''), 'dropPhoneNumber')}
                        value={quoteData?.dropPhoneNumber}
                    />
                </div>
            </div>

            <div className="w-full">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">
                    Drop Address Additional Info
                </label>
                <input
                    type="text"
                    name="endBuilding"
                    className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    onChange={(event: any) => handleChange(event.target.value, 'endBuilding')}
                    value={quoteData?.endBuilding}
                />
            </div>
        </div>

    )
}